import Button from '@src/components/coreUI/button';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import Image from 'next/image';
import CoreImage from '@src/components/coreUI/image';
import { Lato } from 'next/font/google';
import { useRouter, useSearchParams } from 'next/navigation';
import { APP_ROUTE } from '@src/constants/routes';
import clsx from 'clsx';

// import { Disclosure, Tab } from '@headlessui/react';
import SelectUserTypeDialog from '@src/components/selectUserTypeDialog';
// import Minus from '@src/assets/svg/minus';
import Icon from '@src/components/coreUI/icon';
// import IconButton from '@src/components/coreUI/iconButton';
import { getProperties } from '@src/services/properties';
import usePropertyListing from '@src/hooks/usePropertyListing';
import PropertyCard from '@src/components/propertyCard';
import { ZEME_USERS_ROLE } from '@src/constants/configs';
import { Property } from '@src/interfaces/app/propertyLists';
import {
  propertyURLSearchBuilder,
  transformAllPublicPropertiesData,
} from '@src/utils/helper';
import PropertyListShimmer from '@src/components/propertyListShimmer';
import SearchAutocomplete from '../searchAutocomplete';
import { AddressAutoSearch } from '@src/interfaces/components/searchAutocomplete';
import {
  getUserType,
  clearNylasModalDismissalState,
} from '@src/utils/localStorage';
import Search from '@src/assets/svg/search';
import { Menu, Transition } from '@headlessui/react';
import useProfile from '@src/hooks/useProfile';
import Loader from '@src/components/loader';
import useLoader from '@src/hooks/useLoader';
import { logoutUser } from '@src/services/auth';
import { showSuccessMsg } from '@src/utils/notifications';
import { AUTH_MSG } from '@src/constants/messages';
import AdvertisementContactFunnel from '../advertisementContactFunnel';
import CalendlyForm from '@src/components/advertisementContactFunnel/calendly';
import { useWindowSize } from '@react-hook/window-size';

const lato = Lato({
  weight: ['300', '400', '700', '900'],
  subsets: ['latin'],
  display: 'swap',
});

interface observeTypes {
  // eslint-disable-next-line no-unused-vars
  unobserve: (target: Element) => void;
  // eslint-disable-next-line no-unused-vars
  observe: (target: Element) => void;
}

interface ContactFormTypes {
  fullName: string;
  email: string;
  phoneNumber: string;
  companyName: string;
}

let initialValues: ContactFormTypes = {
  fullName: '',
  email: '',
  phoneNumber: '',
  companyName: '',
};

function LandingComponent() {
  // Hooks
  const { push } = useRouter();
  const { profile, setProfile } = useProfile();
  const { isLoading, showLoader, hideLoader } = useLoader();
  const { propertyList = [], setPropertyList } = usePropertyListing();
  const size = useWindowSize();

  // State
  // const [observer, setObserver] = useState<observeTypes | null>(null);
  const [isVisibleUserTypeDialog, setIsVisibleUserTypeDialog] = useState(false);
  const [isFetchingProperty, setIsFetchingProperty] = useState(false);
  const [isOpenContactForm, setIsOpenContactForm] = useState(false);
  const [isOpenCalendy, setIsOpenCalendy] = useState(false);
  const [landingPageBtnWidth, setLandingPageBtnWidth] = useState('md');
  // const [authType] = useState('');
  const [authType, setAuthType] = useState('');

  const searchParams = useSearchParams();
  const isShowContactForm = searchParams?.get('showDemoModel');

  const avatarStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '100%',
  };

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ');
  }

  // Classes variable
  const mainClasses = clsx(lato.className, 'flex flex-col');

  useEffect(() => {
    const [width] = size;

    // Done to prevent reload when not needed
    const btnWidth = width < 850 ? 'smTwo' : 'lg';

    if (btnWidth != landingPageBtnWidth)
      setLandingPageBtnWidth(width < 850 ? 'smTwo' : 'lg');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  /**
   * This method is used to toggle classes of the instances of IntersectionObserver
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setClasses = function (entries: any[]) {
    entries.forEach(
      (entry: {
        isIntersecting: boolean;
        target: {
          classList: {
            // eslint-disable-next-line no-unused-vars
            add: (classes: string) => void;
            // eslint-disable-next-line no-unused-vars
            remove: (classes: string) => void;
          };
        };
      }) => {
        entry.isIntersecting
          ? entry.target.classList.add('go-animation')
          : entry.target.classList.remove('go-animation');
      }
    );
  };

  /**
   * This method is used to Remove the instances of IntersectionObserver
   */
  // const removeInstances = (observer: observeTypes) => {
  //   if (observer) {
  //     const targets = document.querySelectorAll('.show-on-scroll');
  //     targets.forEach((target: Element) => {
  //       observer.unobserve(target);
  //     });
  //   }
  // };

  /**
   * This method is used to initialize the instances of IntersectionObserver
   */
  const initializeInstances = useCallback((observer: observeTypes) => {
    if (observer) {
      const targets = document.querySelectorAll('.show-on-scroll');
      targets.forEach((target: Element) => {
        observer.observe(target);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Fetch public property
   */
  const fetchPublicProperty = useCallback(async () => {
    try {
      setIsFetchingProperty(true);
      const { results = [] } = await getProperties(
        '?page=1&limit=4&offset=0&feature=true',
        false,
        5,
        0
      );
      const properties = transformAllPublicPropertiesData(results);
      setPropertyList(properties);
    } catch (error) {
      console.error(error);
    } finally {
      setIsFetchingProperty(false);
    }
  }, [setPropertyList]);

  /**
   * Lifecycle hook
   */
  useEffect(() => {
    const observer = new IntersectionObserver(setClasses);

    // setObserver(observer);
    initializeInstances(observer);
  }, [initializeInstances]);

  useEffect(() => {
    fetchPublicProperty();
    return () => {
      setPropertyList([]);
    };
  }, [fetchPublicProperty, setPropertyList]);

  /**
   * Lifecycle hook
   */
  useEffect(() => {
    if (Boolean(isShowContactForm)) setIsOpenContactForm(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Handlesearch
   *
   * @param e Event
   */
  const handleSearchChange = (address: AddressAutoSearch[] | null) => {
    if (address) {
      const url = '';
      const filterURL = propertyURLSearchBuilder(
        address as AddressAutoSearch[],
        url
      );

      const appExploreURL = `${APP_ROUTE.EXPLORE}${filterURL}`;
      push(appExploreURL);
      return;
    }
  };

  /**
   * Clears the local storage, sets the user as logged out, and redirects to the home page.
   *
   * @return {void} No return value.
   */
  const handleLogout = async () => {
    try {
      showLoader();
      await logoutUser();

      showSuccessMsg(AUTH_MSG.logoutSuccess);
      localStorage.clear();
      clearNylasModalDismissalState(); // Clear modal dismissal state on logout
      if (setProfile) setProfile(null);
    } catch (error) {
      console.error(error);
    } finally {
      hideLoader();
    }
  };

  return (
    <>
      <div className={mainClasses}>
        <header className="fixed inset-0 bg-white py-7 w-full h-[80px] shrink-0 z-20">
          <nav className="relative h-full flex justify-between items-center max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto px-4 md:px-0">
            <div className="">
              <a className="flex items-center cursor-pointer">
                <Image
                  src="/zeme-colored-logo.png"
                  alt="Zeme Logo"
                  width={145}
                  height={32}
                />
              </a>
            </div>
            <div className="flex items-center gap-x-1 xs:gap-x-4">
              {!profile ? (
                <>
                  <Button
                    variant="primary"
                    size="sm"
                    extraClasses="!font-extrabold"
                    onClick={() => push(APP_ROUTE.LOGIN)}
                  >
                    Login
                  </Button>
                  <Button
                    variant="blueOutline"
                    size="sm"
                    extraClasses="!font-extrabold hidden xs:flex"
                    onClick={() => setIsOpenContactForm(true)}
                  >
                    Book a demo!
                  </Button>
                </>
              ) : null}
              {profile && (
                <div className="flex items-center ">
                  <span className="sm:inline-block mr-3 hidden">{`${profile?.generalInformation?.firstName} ${profile?.generalInformation?.lastName}`}</span>

                  <Menu as="div" className="relative flex text-left">
                    <Menu.Button>
                      <Image
                        src="/user-avatar.svg"
                        width={40}
                        height={40}
                        alt="Rounded avatar"
                        style={avatarStyle}
                      />
                    </Menu.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 top-full z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg focus:outline-none">
                        <div className="py-1">
                          {profile && (
                            <span className="text-gray-dark inline-block px-4 py-1.5 text-xs uppercase sm:hidden">{`${profile?.generalInformation?.firstName} ${profile?.generalInformation?.lastName}`}</span>
                          )}
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => {
                                  push(APP_ROUTE.EXPLORE);
                                }}
                                className={classNames(
                                  active
                                    ? 'bg-gray-100 text-black-light'
                                    : 'text-black-light',
                                  'block w-full px-4 py-2 text-left text-sm'
                                )}
                              >
                                Explore
                              </button>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={handleLogout}
                                className={classNames(
                                  active
                                    ? 'bg-gray-100 text-black-light'
                                    : 'text-black-light',
                                  'block w-full px-4 py-2 text-left text-sm'
                                )}
                              >
                                Sign out
                              </button>
                            )}
                          </Menu.Item>
                        </div>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              )}

              {/* <Button
                variant="secondary"
                size="sm"
                extraClasses="!font-extrabold hidden xs:flex"
                onClick={() => {
                  setAuthType('register');
                  setIsVisibleUserTypeDialog(true);
                }}
              >
                Register
              </Button> */}
              {/* <Menu
                as="div"
                className="relative inline-block text-left xs:hidden"
              >
                <>
                  <div>
                    <Menu.Button className="text-primary-dark hover:text-primary-light">
                      <Icon
                        iconName="userAvatar"
                        iconProps={{
                          className: 'h-8 w-8',
                        }}
                      />
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute w-40 right-0 z-10 mt-1 origin-top-right rounded-xl bg-white shadow-container focus:outline-none">
                      <div className="py-1.5">
                        <Menu.Item>
                          <a
                            href="#"
                            className="text-black-dark block px-4 py-3 text-base hover:bg-blue-dark/10"
                            onClick={() => push(APP_ROUTE.LOGIN)}
                          >
                            Login
                          </a>
                        </Menu.Item>
                        <Menu.Item>
                          <a
                            href="#"
                            className="text-black-dark block px-4 py-3 text-base hover:bg-blue-dark/10"
                            onClick={() => {
                              setAuthType('register');
                              setIsVisibleUserTypeDialog(true);
                            }}
                          >
                            Register
                          </a>
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </>
              </Menu> */}
            </div>
          </nav>
        </header>
        <main className="flex-auto mt-[80px]">
          {/* hero section */}
          <section className="banner-overlay bg-bottom bg-cover bg-no-repeat w-full">
            <div className="py-16">
              <div className="xs:pt-10 max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto flex flex-col flex-wrap sm:flex-nowrap sm:flex-row items-center sm:justify-between gap-12 sm:gap-7 show-on-scroll group px-4 md:px-0">
                <div className="flex-shrink-0 basis-full max-w-full xs:max-w-lg sm:max-w-md md:max-w-lg sm:basis-1/2 sm:text-left text-center group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                  <h1 className="text-[36px] font-extrabold text-white sm:text-[44px] sm:leading-[4.5rem]">
                    Apply, Sign, and Manage all in ONE platform!
                  </h1>
                  <p className="mt-2 sm:mt-5 text-lg sm:text-lg sm:text-22 leading-8 text-white">
                    Effortlessly apply, sign leases, and manage your property
                    with Zeme&apos;s all-in-one platform.
                  </p>
                  {!profile ? (
                    <div className="mt-10 m-auto max-w-sm flex flex-col flex-wrap sm:flex-nowrap items-center gap-4 justify-center sm:justify-start">
                      <div className="flex flex-nowrap gap-4 justify-center sm:justify-start">
                        <Button
                          variant="primary"
                          size={landingPageBtnWidth}
                          extraClasses="min-w-[160px] !sm:min-w-[180px] !font-bold"
                          onClick={() => {
                            push(APP_ROUTE.EXPLORE);
                          }}
                        >
                          I am a Renter
                        </Button>
                        <Button
                          variant="secondary"
                          size={landingPageBtnWidth}
                          extraClasses="min-w-[160px] !sm:min-w-[180px] !font-bold"
                          onClick={() => {
                            setAuthType('register');
                            setIsVisibleUserTypeDialog(true);
                          }}
                        >
                          I have listings
                        </Button>
                      </div>
                      <Button
                        variant="blueOutline"
                        size={landingPageBtnWidth}
                        extraClasses="w-full !max-w-[316px] !font-bold flex xs:hidden"
                        onClick={() => {
                          setIsOpenContactForm(true);
                        }}
                      >
                        Book a demo!
                      </Button>
                    </div>
                  ) : null}

                  {profile ? (
                    <div className="mt-10 flex flex-wrap sm:flex-nowrap items-center gap-4 justify-center sm:justify-start">
                      {getUserType() === ZEME_USERS_ROLE.RENTER ? (
                        <Button
                          variant="primary"
                          size="lg"
                          extraClasses="!min-w-[180px] !font-bold"
                          onClick={() => {
                            push(APP_ROUTE.EXPLORE);
                          }}
                        >
                          Explore
                        </Button>
                      ) : null}
                      {getUserType() === ZEME_USERS_ROLE.AGENT ||
                      getUserType() === ZEME_USERS_ROLE.LANDLORD ? (
                        <Button
                          variant="secondary"
                          size="lg"
                          extraClasses="!min-w-[180px] !font-bold"
                          onClick={() => push(APP_ROUTE.AGENT_DASHBOARD)}
                        >
                          View Dashboard
                        </Button>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="flex basis-full sm:basis-3/5  shrink-0 group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                  <div className="w-full h-full">
                    <Image
                      src="/assets/landing-page/platform.png"
                      width="1000"
                      height="1000"
                      alt="Platform"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="mx-auto group show-on-scroll">
                <div className="group-[.go-animation]:animate-fade-up group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                  <h2 className="text-22 text-center font-semibold text-white sm:text-[30px] sm:leading-[4.5rem] opacity-50 flex items-center justify-center">
                    <div className="w-60 border-t border-gray-lighter opacity-30 mr-4"></div>
                    Integrations
                    <div className="w-60 border-t border-gray-lighter opacity-30 ml-4"></div>
                  </h2>
                </div>
                <div className="overflow-hidden group-[.go-animation]:animate-fade-up group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                  <div className="logo-slider">
                    <div className="mx-auto flex mt-8 items-center grayscale animate-scroll-mobile xs:animate-scroll-tablet md:animate-scroll-desktop w-[calc(180px*20)] xs:w-[calc(250px*20)] md:w-[calc(300px*20)]">
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/usaa.svg"
                          alt="USSA"
                          style={{
                            width: '170px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left"
                          src="/assets/landing-page/US-bank.svg"
                          alt="US Bank"
                          style={{
                            width: '170px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/transunion.svg"
                          alt="Transunion"
                          style={{
                            width: '230px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/docusign.svg"
                          alt="DocuSign"
                          style={{
                            width: '180px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/plaid.svg"
                          alt="Plaid"
                          style={{
                            width: '180px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/chase.svg"
                          alt="Chase"
                          style={{
                            width: '160px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0 "
                          src="/assets/landing-page/BOA.svg"
                          alt="Bank of America"
                          style={{
                            width: '260px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-16 m-auto object-contain object-left opacity-50"
                          src="/assets/landing-page/well-fargo.png"
                          alt="Well Fargo"
                          style={{
                            width: '100px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/capital-one.svg"
                          alt="Capital One"
                          style={{
                            width: '260px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/robinhood.svg"
                          alt="Robinhood"
                          style={{
                            width: '260px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>

                      {/* Repeating 9 slides */}
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/usaa.svg"
                          alt="USSA"
                          style={{
                            width: '170px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left"
                          src="/assets/landing-page/US-bank.svg"
                          alt="US Bank"
                          style={{
                            width: '170px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/transunion.svg"
                          alt="Transunion"
                          style={{
                            width: '230px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/docusign.svg"
                          alt="DocuSign"
                          style={{
                            width: '180px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/plaid.svg"
                          alt="Plaid"
                          style={{
                            width: '180px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/chase.svg"
                          alt="Chase"
                          style={{
                            width: '160px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0 "
                          src="/assets/landing-page/BOA.svg"
                          alt="Bank of America"
                          style={{
                            width: '260px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-16 m-auto object-contain object-left opacity-50"
                          src="/assets/landing-page/well-fargo.png"
                          alt="Well Fargo"
                          style={{
                            width: '100px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/capital-one.svg"
                          alt="Capital One"
                          style={{
                            width: '260px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                      <div className="w-[180px] xs:w-[250px] md:w-[300px] h-16 items-center flex max-w-full px-4 xs:px-0 box-border">
                        <CoreImage
                          className="max-h-12 m-auto object-contain object-left contrast-0"
                          src="/assets/landing-page/robinhood.svg"
                          alt="Robinhood"
                          style={{
                            width: '260px',
                            height: '100%',
                            margin: 'auto',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto px-4 md:px-0">
            <div className="relative max-w-3xl m-auto rounded-full bg-white -top-[32px] shadow-light-color">
              <div className="absolute left-5 z-10 flex items-center h-full w-16 text-gray-dark/60">
                <span className="flex justify-center items-center w-5 h-5 text-gray-dark/70">
                  <Search />
                </span>
              </div>
              <SearchAutocomplete
                onSelect={(address: AddressAutoSearch[] | null) =>
                  handleSearchChange(address)
                }
                extraClasses="landing-search"
              />
              {/* <div className="absolute right-3 z-10 flex items-center h-full top-0">
                <Button
                  variant="primary"
                  size="sm"
                  extraClasses="!font-bold"
                  onClick={() => push(APP_ROUTE.RENTER_REGISTER)}
                >
                  Search
                </Button>
              </div> */}
            </div>
          </section>

          {/* listing section */}
          <section className="max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto px-4 md:px-0 group show-on-scroll">
            <div className="pt-24 pb-10 group-[.go-animation]:animate-fade-up group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
              <h2 className="font-extrabold text-3xl sm:text-44 text-black-light text-center capitalize mb-16">
                Newly listed homes in
                <span className="text-primary-dark ml-3">New York</span>
              </h2>
              <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-4 mx-auto mb-10">
                {isFetchingProperty ? <PropertyListShimmer /> : null}
                {propertyList &&
                  propertyList.map((property: Property) => {
                    const image =
                      property?.imageInformation?.images?.length > 0
                        ? (property.imageInformation.images[0]
                            .thumbnail as string)
                        : '';

                    return (
                      <PropertyCard
                        key={property.id}
                        id={property.id}
                        role={ZEME_USERS_ROLE.RENTER}
                        isMyListing={false}
                        image={image}
                        name={property.generalInformation?.propertyName}
                        price={property.economicInformation?.cost}
                        updatedPrice={property.economicInformation?.updatedCost}
                        address={property.generalInformation?.address}
                        bath={property.generalInformation?.bathrooms}
                        bedroom={property.generalInformation?.bedrooms}
                        squareFootage={
                          property.generalInformation?.squareFootage
                        }
                        unitCode={
                          property.generalInformation?.address?.unitCode
                        }
                        isEasyApply={
                          property.generalInformation?.isEasyApply || false
                        }
                        handleSaveUnsaveProperty={() => {
                          return;
                        }}
                        isSaved={Boolean(property?.isSave)}
                        isExclusive={property?.generalInformation?.isExclusive}
                      />
                    );
                  })}
              </div>

              <div className="flex justify-center items-center">
                <Button
                  extraClasses="flex items-center"
                  onClick={() => {
                    push(APP_ROUTE.EXPLORE);
                  }}
                >
                  Explore More{' '}
                  <Icon
                    iconName="arrowdown"
                    iconProps={{ class: 'ml-2 text-white' }}
                  />
                </Button>
              </div>
            </div>
          </section>

          {/* how it works */}
          <section className="pt-24">
            <div className="">
              <div className="group show-on-scroll">
                <h2 className="font-extrabold text-3xl sm:text-44 text-black-light mb-4 text-center capitalize group-[.go-animation]:animate-fade-up group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                  How It
                  <span className="text-primary-dark ml-3">Works</span>
                </h2>
                <p className="text-lg px-2 sm:text-22 text-gray-dark text-center group-[.go-animation]:animate-fade-up group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                  Connecting Real Renters with Agents for a Seamless Rental
                  Journey
                </p>
              </div>
              <div className="pt-10 relative">
                <div className="max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto py-20 xs:py-28 flex sm:flex-row flex-col w-full items-center gap-7 justify-between group show-on-scroll px-4 md:px-0">
                  <div className="basis-3/5 group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                    <Image
                      src="/assets/landing-page/property.png"
                      width="1000"
                      height="1000"
                      alt="thumbnail title"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                  <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                    <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 relative">
                      <span className="text-44 xs:text-[120px] text-[#B6D1F6]/50 self-baseline absolute -left-12 -top-3 -z-10">
                        1
                      </span>
                      <span className="text-primary-dark">Begin</span> Your
                      Property Search
                    </h3>

                    <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                      Find properties that meet your exact needs—use our
                      detailed filters to sort by location, price, amenities,
                      and more. From the comfort of a snug studio to the luxury
                      of a large family residence, our extensive network of
                      agents, brokers, and landlords ensures you have access to
                      a wide range of options for every preference and price
                      range.
                    </p>
                  </div>
                </div>
                <div className="relative bg-blue-dark/20 xs:rounded-tl-[150px] xs:rounded-br-[150px] py-20">
                  <div className="landing-blue-bg bg-contain left-0 bottom-[calc(100%-2px)] xs:h-[112px] top-auto bg-right bg-no-repeat absolute right-0"></div>
                  <div className="landing-blue-bg bg-contain left-0 top-[calc(100%-2px)] xs:h-[112px] transform rotate-180 bg-right bg-no-repeat absolute right-0 "></div>
                  <div className="blue-side-layer bg-contain left-0 top-auto bottom-10 xs:h-[400px] bg-left bg-no-repeat absolute right-0"></div>
                  <div className="max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto flex w-full sm:flex-row flex-col-reverse items-center gap-7 justify-between group show-on-scroll px-4 md:px-0">
                    <div className="basis-1/2 max-w-xl sm:max-w-md group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                      <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 relative">
                        <span className="text-44 xs:text-[120px] text-[#B6D1F6] self-baseline absolute -left-12 -top-3 -z-10">
                          2
                        </span>
                        <span className="text-primary-dark">Find</span> The Best
                        Match
                      </h3>
                      <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                        Browse through properties and select the one that aligns
                        with your budget, commute, and location preferences.
                      </p>
                    </div>
                    <div className="basis-3/5 group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                      <Image
                        src="/assets/landing-page/best-choice.png"
                        width="1000"
                        height="1000"
                        alt="thumbnail title"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto py-20 xs:py-32 flex sm:flex-row flex-col w-full items-center gap-7 justify-between group show-on-scroll px-4 md:px-0">
                  <div className="basis-3/5 group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                    <Image
                      src="/assets/landing-page/apply.png"
                      width="1000"
                      height="1000"
                      alt="thumbnail title"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                  <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                    <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 relative">
                      <span className="text-44 xs:text-[120px] text-[#B6D1F6]/50 self-baseline absolute -left-12 -top-3 -z-10">
                        3
                      </span>
                      <span className="text-primary-dark">Easy</span> To Apply
                    </h3>

                    <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                      Our platform simplifies the rental application journey. In
                      just a few clicks, apply for the property you&apos;ve set
                      your heart on. Just upload the necessary documents and
                      you&apos;re a few steps away from making it yours.
                    </p>
                  </div>
                </div>
                <div className="relative bg-blue-dark/20 xs:rounded-tr-[150px] py-24">
                  <div className="landing-blue-bg bg-contain left-0 bottom-[calc(100%-2px)] xs:h-[112px] transform scale-x-[-1] top-auto bg-right bg-no-repeat absolute right-0"></div>
                  <div className="blue-side-layer bg-contain right-0 bottom-[auto] top-[30%] xs:h-[280px] bg-left transoform rotate-180 bg-no-repeat absolute left-0"></div>

                  <div className="max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto flex sm:flex-row flex-col-reverse w-full items-center gap-6 justify-between group show-on-scroll px-4 md:px-0">
                    <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                      <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 relative">
                        <span className="text-44 xs:text-[120px] text-[#B6D1F6] self-baseline absolute -left-12 -top-3 -z-10">
                          4
                        </span>
                        <span className="text-primary-dark leading-[60px]">
                          Directly
                        </span>{' '}
                        Connect <br /> With An Agent
                      </h3>
                      <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                        Bypass the wait for emails or calls. Click on the chat
                        icon adjacent to a listing and instantly engage with an
                        agent ready to address your queries and set up property
                        viewings.
                      </p>
                    </div>
                    <div className="basis-1/2 group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                      <Image
                        src="/assets/landing-page/chat.png"
                        width="1000"
                        height="1000"
                        alt="thumbnail title"
                        style={{
                          width: 'auto',
                          height: 'auto',
                          objectFit: 'cover',
                          margin: 'auto',
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* <Tab.Group
                  onChange={() => {
                    if (observer) {
                      removeInstances(observer);
                      setTimeout(() => {
                        initializeInstances(observer);
                      }, 300);
                    }
                  }}
                >
                  <Tab.List className="w-full bg-baseBg sticky py-4 top-0 z-20">
                    <div className="flex rounded-full max-w-sm justify-center mx-auto bg-lightertwo/30">
                      <Tab
                        className={({ selected }) => {
                          return `w-full rounded-full py-3 text-lg font-medium text-black-dark focus:outline-none focus-visible:outline-none ${
                            selected
                              ? 'bg-gradient-to-r from-blue-dark to-blue-light font-semibold text-white'
                              : 'text-gray-dark hover:text-primary-dark'
                          }`;
                        }}
                      >
                        Renters
                      </Tab>
                      <Tab
                        className={({ selected }) => {
                          return `w-full rounded-full py-3 text-lg font-medium text-black-dark focus:outline-none focus-visible:outline-none ${
                            selected
                              ? 'bg-gradient-to-r from-blue-dark to-blue-light font-semibold text-white'
                              : 'text-gray-dark hover:text-primary-dark'
                          }`;
                        }}
                      >
                        Agents
                      </Tab>
                    </div>
                  </Tab.List>

                  <Tab.Panels className="">
                    <Tab.Panel className="">
                      <div className="max-w-[95%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto py-20 xs:py-28 flex sm:flex-row flex-col w-full items-center gap-7 justify-between group show-on-scroll">
                        <div className="basis-1/2 group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                          <Image
                            src="/assets/landing-page/property.png"
                            width="2000"
                            height="2000"
                            alt="thumbnail title"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </div>
                        <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                          <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 relative">
                            <span className="text-44 xs:text-[120px] text-primary-dark/20 self-baseline">
                              1
                            </span>
                            <span className="text-primary-dark xs:ml-[-10px] ml-2 mr-2">
                              Search
                            </span>{' '}
                            Property
                          </h3>

                          <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                            Find properties that meet your exact needs—filter by
                            location, price, amenities, and more. Whether
                            you&#39;re looking for a cozy studio, a spacious
                            family home, or anything in between, we have
                            something for every lifestyle and budget.
                          </p>
                        </div>
                      </div>
                      <div className="relative bg-blue-dark/20 xs:rounded-tl-[150px] xs:rounded-br-[150px] py-20">
                        <div className="landing-blue-bg bg-contain left-0 bottom-[calc(100%-2px)] xs:h-[112px] top-auto bg-right bg-no-repeat absolute right-0"></div>
                        <div className="landing-blue-bg bg-contain left-0 top-[calc(100%-2px)] xs:h-[112px] transform rotate-180 bg-right bg-no-repeat absolute right-0 "></div>
                        <div className="blue-side-layer bg-contain left-0 top-auto bottom-10 xs:h-[400px] bg-left bg-no-repeat absolute right-0"></div>
                        <div className="max-w-[95%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto flex w-full sm:flex-row flex-col-reverse items-center gap-7 justify-between group show-on-scroll">
                          <div className="basis-1/2 max-w-xl sm:max-w-md group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                            <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 relative">
                              <span className="text-44 xs:text-[120px] text-primary-dark/20 self-baseline">
                                2
                              </span>
                              <span className="text-primary-dark xs:ml-[-10px] ml-2 mr-2">
                                Select
                              </span>{' '}
                              Best Choice
                            </h3>
                            <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                              Compare various properties and choose the one
                              that&#39;s perfect for you, based on budget,
                              commute time, and location.
                            </p>
                          </div>
                          <div className="basis-1/2 group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                            <Image
                              src="/assets/landing-page/best-choice.png"
                              width="3000"
                              height="3000"
                              alt="thumbnail title"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="max-w-[95%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto py-20 xs:py-32 flex sm:flex-row flex-col w-full items-center gap-7 justify-between group show-on-scroll">
                        <div className="basis-1/2 group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                          <Image
                            src="/assets/landing-page/apply.png"
                            width="2000"
                            height="2000"
                            alt="thumbnail title"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </div>
                        <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                          <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 flex xs:items-center">
                            <span className="text-44 xs:text-[120px] text-primary-dark/20 self-baseline">
                              3
                            </span>
                            <span className="text-primary-dark xs:ml-[-10px] ml-2 mr-2">
                              Easy
                            </span>{' '}
                            To Apply
                          </h3>

                          <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                            Streamlining the rental application process, our
                            platform enables you to apply for your dream
                            property in just a few clicks. Simply upload the
                            required documents and submit your application in a
                            few easy steps
                          </p>
                        </div>
                      </div>
                      <div className="relative bg-blue-dark/20 xs:rounded-tr-[150px] py-24">
                        <div className="landing-blue-bg bg-contain left-0 bottom-[calc(100%-2px)] xs:h-[112px] transform scale-x-[-1] top-auto bg-right bg-no-repeat absolute right-0"></div>
                        <div className="blue-side-layer bg-contain right-0 bottom-[auto] top-[30%] xs:h-[280px] bg-left transoform rotate-180 bg-no-repeat absolute left-0"></div>

                        <div className="max-w-[95%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto flex sm:flex-row flex-col-reverse w-full items-center gap-7 justify-between group show-on-scroll">
                          <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                            <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 flex xs:items-center">
                              <span className="text-44 xs:text-[120px] text-primary-dark/20 self-baseline">
                                4
                              </span>
                              <span className="text-primary-dark xs:ml-[-10px] ml-2 mr-2">
                                Chat
                              </span>{' '}
                              Directly with agent{' '}
                            </h3>
                            <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                              No more waiting for email replies or phone calls.
                              Simply click the chat icon next to a listing to
                              connect immediately with an agent who can answer
                              your questions and arrange property visit.
                            </p>
                          </div>
                          <div className="basis-1/2 group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                            <Image
                              src="/assets/landing-page/chat.png"
                              width="1500"
                              height="1500"
                              alt="thumbnail title"
                              style={{
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'cover',
                                margin: 'auto',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab.Panel>
                    <Tab.Panel className="" data-theme="agent">
                      <div className="max-w-[95%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto py-20 xs:py-28 flex sm:flex-row flex-col w-full items-center gap-7 justify-between group show-on-scroll">
                        <div className="basis-1/2 group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                          <Image
                            src="/assets/landing-page/property.png"
                            width="2000"
                            height="2000"
                            alt="thumbnail title"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </div>
                        <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                          <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 relative">
                            <span className="text-44 xs:text-[120px] text-primary-dark/20 self-baseline">
                              1
                            </span>
                            <span className="text-primary-dark xs:ml-[-10px] ml-2 mr-2">
                              Search
                            </span>{' '}
                            Property
                          </h3>

                          <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                            Find properties that meet your exact needs—filter by
                            location, price, amenities, and more. Whether
                            you&#39;re looking for a cozy studio, a spacious
                            family home, or anything in between, we have
                            something for every lifestyle and budget.
                          </p>
                        </div>
                      </div>
                      <div className="relative bg-primary-dark/20 xs:rounded-tl-[150px] xs:rounded-br-[150px] py-20">
                        <div className="landing-pink-bg bg-contain left-0 bottom-[calc(100%-2px)] xs:h-[112px] top-auto bg-right bg-no-repeat absolute right-0"></div>
                        <div className="landing-pink-bg bg-contain left-0 top-[calc(100%-2px)] xs:h-[112px] transform rotate-180 bg-right bg-no-repeat absolute right-0 "></div>
                        <div className="pink-side-layer bg-contain left-0 top-auto bottom-10 xs:h-[400px] bg-left bg-no-repeat absolute right-0"></div>
                        <div className="max-w-[95%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto flex w-full sm:flex-row flex-col-reverse items-center gap-7 justify-between group show-on-scroll">
                          <div className="basis-1/2 max-w-xl sm:max-w-md group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                            <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 relative">
                              <span className="text-44 xs:text-[120px] text-primary-dark/20 self-baseline">
                                2
                              </span>
                              <span className="text-primary-dark xs:ml-[-10px] ml-2 mr-2">
                                Select
                              </span>{' '}
                              Best Choice
                            </h3>
                            <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                              Compare various properties and choose the one
                              that&#39;s perfect for you, based on budget,
                              commute time, and location.
                            </p>
                          </div>
                          <div className="basis-1/2 group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                            <Image
                              src="/assets/landing-page/best-choice.png"
                              width="3000"
                              height="3000"
                              alt="thumbnail title"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="max-w-[95%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto py-20 xs:py-32 flex sm:flex-row flex-col w-full items-center gap-7 justify-between group show-on-scroll">
                        <div className="basis-1/2 group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                          <Image
                            src="/assets/landing-page/apply.png"
                            width="2000"
                            height="2000"
                            alt="thumbnail title"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </div>
                        <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                          <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 flex xs:items-center">
                            <span className="text-44 xs:text-[120px] text-primary-dark/20 self-baseline">
                              3
                            </span>
                            <span className="text-primary-dark xs:ml-[-10px] ml-2 mr-2">
                              Easy
                            </span>{' '}
                            To Apply
                          </h3>

                          <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                            Streamlining the rental application process, our
                            platform enables you to apply for your dream
                            property in just a few clicks. Simply upload the
                            required documents and submit your application in a
                            few easy steps
                          </p>
                        </div>
                      </div>
                      <div className="relative bg-primary-dark/20 xs:rounded-tr-[150px] py-24">
                        <div className="landing-pink-bg bg-contain left-0 bottom-[calc(100%-2px)] xs:h-[112px] transform scale-x-[-1] top-auto bg-right bg-no-repeat absolute right-0"></div>
                        <div className="pink-side-layer bg-contain right-0 bottom-[auto] top-[30%] xs:h-[280px] bg-left transoform rotate-180 bg-no-repeat absolute left-0"></div>

                        <div className="max-w-[95%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto flex sm:flex-row flex-col-reverse w-full items-center gap-7 justify-between group show-on-scroll">
                          <div className="basis-1/2 max-w-xl group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                            <h3 className="text-[36px] sm:text-[42px] leading-10 font-extrabold mb-4 flex xs:items-center">
                              <span className="text-44 xs:text-[120px] text-primary-dark/20 self-baseline">
                                4
                              </span>
                              <span className="text-primary-dark xs:ml-[-10px] ml-2 mr-2">
                                Chat
                              </span>{' '}
                              Directly with agent{' '}
                            </h3>
                            <p className="text-base sm:text-xl text-gray-dark/80 leading-8">
                              No more waiting for email replies or phone calls.
                              Simply click the chat icon next to a listing to
                              connect immediately with an agent who can answer
                              your questions and arrange property visit.
                            </p>
                          </div>
                          <div className="basis-1/2 group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                            <Image
                              src="/assets/landing-page/chat.png"
                              width="1500"
                              height="1500"
                              alt="thumbnail title"
                              style={{
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'cover',
                                margin: 'auto',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group> */}
              </div>
            </div>
          </section>

          {/* available on mobile and web */}
          <section className="mb-[-2px]">
            <div className="bg-black-overlay bg-bottom bg-no-repeat bg-cover w-full group show-on-scroll">
              <div className="max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto py-8 xs:py-12 flex sm:flex-row flex-col w-full items-center gap-7 justify-between px-4 md:px-0">
                <div className="flex basis-1/2 group-[.go-animation]:animate-fade-right group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                  <div className="w-full max-w-xl">
                    <Image
                      src="/assets/landing-page/Phone.png"
                      width="1000"
                      height="1000"
                      alt="Mobile App"
                      style={{
                        width: '100%',
                        height: '650px',
                        objectFit: 'contain',
                        margin: 'auto',
                      }}
                    />
                  </div>
                </div>
                <div className="max-w-xl basis-1/2 text-center sm:text-left group-[.go-animation]:animate-fade-left group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
                  <h1 className="text-3xl font-extrabold text-white sm:text-44 xs:leading-[3.5rem] capitalize">
                    <span className="text-blue-dark mr-3">Know</span> where you
                    are at every step
                  </h1>
                  <p className="mt-4 text-lg sm:text-22 leading-8 text-white">
                    Effortlessly track each application you submit.
                  </p>
                  <p className="mt-6 xs:text-[24px] text-pink-dark">
                    Download our mobile app for easy access to all features
                    while on the go.
                  </p>
                  <div className="flex gap-3 mt-12 justify-center sm:justify-start">
                    <a
                      href="https://apps.apple.com/in/app/zeme-real-estate-rentals/id6450527319"
                      target="_blank"
                      className="hover:opacity-80"
                    >
                      <Image
                        src="/assets/landing-page/app-store.png"
                        width="250"
                        height="250"
                        alt="App Store"
                        style={{
                          width: '100%',
                          height: '65px',
                          objectFit: 'contain',
                        }}
                      />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.rentzeme.zeme"
                      target="_blank"
                      className="hover:opacity-80"
                    >
                      <Image
                        src="/assets/landing-page/play-store.png"
                        width="250"
                        height="250"
                        alt="Play Store"
                        style={{
                          width: '100%',
                          height: '65px',
                          objectFit: 'contain',
                        }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ */}
          {/* <section className="max-w-[90%] md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] mx-auto group show-on-scroll">
            <div className="py-20 xs:py-24 group-[.go-animation]:animate-fade-up group-[.go-animation]:animate-once group-[.go-animation]:animate-ease-in-out group-[.go-animation]:animate-alternate group-[.go-animation]:animate-fill-forwards opacity-0">
              <h2 className="font-extrabold text-3xl sm:text-44 text-black-light mb-10 text-center">
                Frequently Asked
                <span className="text-primary-dark ml-3">Questions</span>
              </h2>
              <div className="mt-10 space-y-6 divide-y divide-pink-dark/10 p-10 shadow-container bg-white rounded-xl">
                <Disclosure as="div" className="show-on-scroll group">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900 transition duration-700 ease-in-out">
                        <span className="text-lg sm:text-22 font-extrabold leading-7">
                          Have any Trusting issue?
                        </span>
                        <div className="ml-6 flex h-7 items-center">
                          {open ? (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Minus />
                            </IconButton>
                          ) : (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Icon
                                iconName="add"
                                iconProps={{
                                  className: 'h-6 w-6',
                                }}
                              />
                            </IconButton>
                          )}
                        </div>
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 pr-12 xs:w-[80%]">
                        <p className="text-base leading-7 text-gray-600">
                          We believe in open and honest communication. We
                          provide you with all the necessary information about
                          properties, market trends, and the buying or renting
                          process, ensuring you are well-informed.
                        </p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                <Disclosure as="div" className="pt-6">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-lg sm:text-22 font-extrabold leading-7">
                          Do you offer pet-friendly rental properties?
                        </span>
                        <div className="ml-6 flex h-7 items-center">
                          {open ? (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Minus />
                            </IconButton>
                          ) : (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Icon
                                iconName="add"
                                iconProps={{
                                  className: 'h-6 w-6',
                                }}
                              />
                            </IconButton>
                          )}
                        </div>
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 pr-12 xs:w-[80%]">
                        <p className="text-base leading-7 text-gray-600">
                          We believe in open and honest communication. We
                          provide you with all the necessary information about
                          properties, market trends, and the buying or renting
                          process, ensuring you are well-informed.
                        </p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                <Disclosure as="div" className="pt-6">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-lg sm:text-22 font-extrabold leading-7">
                          How is the security deposit handled when I move out?
                        </span>
                        <div className="ml-6 flex h-7 items-center">
                          {open ? (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Minus />
                            </IconButton>
                          ) : (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Icon
                                iconName="add"
                                iconProps={{
                                  className: 'h-6 w-6',
                                }}
                              />
                            </IconButton>
                          )}
                        </div>
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 pr-12 xs:w-[80%]">
                        <p className="text-base leading-7 text-gray-600">
                          We believe in open and honest communication. We
                          provide you with all the necessary information about
                          properties, market trends, and the buying or renting
                          process, ensuring you are well-informed.
                        </p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                <Disclosure as="div" className="pt-6">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-lg sm:text-22 font-extrabold leading-7">
                          What is a lease agreement, and what should it include?
                        </span>
                        <div className="ml-6 flex h-7 items-center">
                          {open ? (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Minus />
                            </IconButton>
                          ) : (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Icon
                                iconName="add"
                                iconProps={{
                                  className: 'h-6 w-6',
                                }}
                              />
                            </IconButton>
                          )}
                        </div>
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 pr-12 xs:w-[80%]">
                        <p className="text-base leading-7 text-gray-600">
                          We believe in open and honest communication. We
                          provide you with all the necessary information about
                          properties, market trends, and the buying or renting
                          process, ensuring you are well-informed.
                        </p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                <Disclosure as="div" className="pt-6">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-lg sm:text-22 font-extrabold leading-7">
                          What factors should I consider when choosing a rental
                          property?
                        </span>
                        <div className="ml-6 flex h-7 items-center">
                          {open ? (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Minus />
                            </IconButton>
                          ) : (
                            <IconButton
                              size="md"
                              onClick={() => ({})}
                              variant="pinkGradient"
                              shape="square"
                            >
                              <Icon
                                iconName="add"
                                iconProps={{
                                  className: 'h-6 w-6',
                                }}
                              />
                            </IconButton>
                          )}
                        </div>
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 pr-12 xs:w-[80%]">
                        <p className="text-base leading-7 text-gray-600">
                          We believe in open and honest communication. We
                          provide you with all the necessary information about
                          properties, market trends, and the buying or renting
                          process, ensuring you are well-informed.
                        </p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              </div>
            </div>
          </section> */}
        </main>

        <footer className="bg-black-dark">
          <div className="mx-auto max-w-full md:max-w-[1200px] lg:max-w-[1366px] xl:max-w-[1500px] pb-8 pt-16 px-4 md:px-0">
            <div className="xl:grid xl:grid-cols-3 xl:gap-8">
              <div className="space-y-2">
                <Image
                  src="/zeme-logo.png"
                  alt="Zeme"
                  style={{
                    width: '150px',
                    height: 'auto',
                  }}
                />
                <p className="text-sm leading-6 text-white">
                  Reinventing the Rental Experience
                </p>
              </div>
              <div className="mt-16 grid xs:grid-cols-3 gap-8 xl:col-span-2 xl:mt-0">
                <div className="xs:grid xs:grid-cols-2 md:gap-8">
                  <div className="md:mt-0">
                    <ul role="list" className="space-y-3">
                      <li>
                        <a
                          target="_blank"
                          href={`${APP_ROUTE.TERMS}`}
                          className="text-sm leading-6 text-white hover:text-white"
                        >
                          Terms of Services
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href={`${APP_ROUTE.PRIVACY}`}
                          className="text-sm leading-6 text-white hover:text-white"
                        >
                          Privacy Policy
                        </a>
                      </li>
                      {/* <li>
                        <a
                          href="#"
                          className="text-sm leading-6 text-white hover:text-white"
                        >
                          About Us
                        </a>
                      </li> */}
                      {/* <li>
                        <a
                          href="#"
                          className="text-sm leading-6 text-white hover:text-white"
                        >
                          Contact Us
                        </a>
                      </li> */}
                      {/* <li>
                        <a
                          href="#"
                          className="text-sm leading-6 text-white hover:text-white"
                        >
                          Blog
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
                <div className="xs:grid xs:grid-cols-1">
                  <ul role="list" className="space-y-3">
                    {/* <li>
                      <a
                        href="#"
                        className="text-sm leading-6 text-white hover:text-white"
                      >
                        Terms of Services
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-sm leading-6 text-white hover:text-white"
                      >
                        Privacy Policy
                      </a>
                    </li> */}
                    {/* <li>
                      <a
                        href="#"
                        className="text-sm leading-6 text-white hover:text-white"
                      >
                        Help
                      </a>
                    </li> */}
                    <li>
                      <a
                        href="mailto:hey@zeme.io"
                        className="flex items-center gap-x-2 text-sm leading-6 text-white hover:text-white"
                      >
                        <Icon
                          iconName="sms"
                          iconProps={{
                            className: 'h-4 w-4',
                          }}
                        />
                        hey@zeme.io
                      </a>
                    </li>
                    {/* <li>
                      <span className="flex items-center gap-x-2 text-sm leading-6 text-white hover:text-white">
                        <Icon
                          iconName="call"
                          iconProps={{
                            className: 'h-4 w-4',
                          }}
                        />
                        1-855-933-ZEME (9363)
                      </span>
                    </li> */}
                  </ul>
                </div>
                <div className="">
                  <ul role="list" className="space-y-3">
                    <li>
                      <span className="flex items-start gap-x-2 text-sm leading-6 text-white hover:text-white">
                        <Icon
                          iconName="location"
                          iconProps={{
                            className: 'h-4 w-4 mt-1.5',
                          }}
                        />
                        Zeme Inc.
                        <br />
                        240 W 40th Street
                        <br /> Floor 2<br />
                        New York, NY 10018
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-8 border-t border-white/20 pt-8 text-center">
              <div className="flex justify-center gap-3 text-white">
                <a
                  href="http://facebook.com/RentZeme"
                  target="_blank"
                  className="hover:opacity-70"
                >
                  <Icon
                    iconName="facebook"
                    iconProps={{
                      className: 'h-8 w-8',
                    }}
                  />
                </a>
                <a
                  href="https://instagram.com/zeme.io"
                  className="hover:opacity-70"
                  target="_blank"
                >
                  <Icon
                    iconName="instagram"
                    iconProps={{
                      className: 'h-8 w-8',
                    }}
                  />
                </a>
                <a
                  href="https://www.tiktok.com/@zeme.io"
                  className="hover:opacity-70"
                  target="_blank"
                >
                  <Icon
                    iconName="tiktok"
                    iconProps={{
                      className: 'h-8 w-8',
                    }}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/zeme-io/"
                  className="hover:opacity-70"
                  target="_blank"
                >
                  <Icon
                    iconName="linkedin"
                    iconProps={{
                      className: 'h-8 w-8',
                    }}
                  />
                </a>
                <a
                  href="https://open.spotify.com/show/0NblLLSnq1dNn4ZsrM6hlW"
                  className="hover:opacity-70"
                  target="_blank"
                >
                  <Icon
                    iconName="spotify"
                    iconProps={{
                      className: 'h-8 w-8',
                    }}
                  />
                </a>
                <a
                  href="https://twitter.com/zeme_io?s=11"
                  className="hover:opacity-70"
                  target="_blank"
                >
                  <Icon
                    iconName="twitter"
                    iconProps={{
                      className: 'h-8 w-8',
                    }}
                  />
                </a>
              </div>
              <p className="text-xs text-white mt-8 tracking-widest">
                © 2023 Zeme Inc. All Rights Reserved.
              </p>
            </div>
          </div>
        </footer>

        {isLoading ? <Loader isVisible={isLoading} /> : null}
      </div>

      {isVisibleUserTypeDialog ? (
        <SelectUserTypeDialog
          isHideRenter
          isVisible={isVisibleUserTypeDialog}
          onClose={() => setIsVisibleUserTypeDialog(false)}
          actionType={authType}
        />
      ) : null}

      {isOpenContactForm ? (
        <AdvertisementContactFunnel
          isOpen={isOpenContactForm}
          onClose={(values) => {
            setIsOpenContactForm(false);
            if (values != undefined) {
              initialValues = values;
              setIsOpenCalendy(true);
            }
          }}
        />
      ) : null}

      {isOpenCalendy ? (
        <CalendlyForm
          isOpen={isOpenCalendy}
          onClose={() => setIsOpenCalendy(false)}
          email={initialValues.email}
          phoneNumber={initialValues.phoneNumber}
          companyName={initialValues.companyName}
          fullName={initialValues.fullName}
        />
      ) : null}
    </>
  );
}

export default LandingComponent;
